import Vue from "vue";
import Router from "vue-router";
import type { Route } from "vue-router";
import type { NavigationGuardNext, RouteConfig } from "vue-router/types/router";
import store from "@/stores";
import { goSignInPage } from "@/utils/commands";
import { useAdminStore } from "@/stores/admin";
import { storeToRefs } from "pinia";

Vue.use(Router);

const requireAuth =
  () => async (_to: Route, _from: Route, next: NavigationGuardNext) => {
    const { loggedIn } = storeToRefs(useAdminStore(store));
    if (loggedIn) {
      return next();
    }
    return goSignInPage();
  };

const routes = (): RouteConfig[] => {
  const management: RouteConfig[] = [
    {
      path: "/management/admin",
      beforeEnter: requireAuth(),
      component: () => import("@/views/management/admin/AdminPage.vue"),
    },
    {
      path: "/management/waiting-user",
      beforeEnter: requireAuth(),
      component: () =>
        import("@/views/management/waiting-user/WaitingUserPage.vue"),
    },
    {
      path: "/management/user",
      beforeEnter: requireAuth(),
      component: () => import("@/views/management/user/UserPage.vue"),
    },
  ];
  const board: RouteConfig[] = [
    {
      path: "/board/notice",
      // beforeEnter: requireAuth(),
      component: () => import("@/views/board/notice/NoticePage.vue"),
    },
    {
      path: "/board/knowledge-sharing",
      beforeEnter: requireAuth(),
      component: () =>
        import("@/views/board/knowledge-sharing/KnowledgeSharingPage.vue"),
    },
    {
      path: "/board/news-room",
      beforeEnter: requireAuth(),
      component: () => import("@/views/board/news-room/NewsRoomPage.vue"),
    },
    {
      path: "/board/faq",
      beforeEnter: requireAuth(),
      component: () => import("@/views/board/faq/FAQPage.vue"),
    },
  ];
  const error: RouteConfig[] = [
    {
      path: "/error",
      component: () => import("@/views/error/UnexpectedPage.vue"),
      meta: {
        layout: "error",
      },
    },
    {
      path: "/error/404",
      component: () => import("@/views/error/NotFoundPage.vue"),
      meta: {
        layout: "error",
      },
    },
  ];

  return [
    {
      path: "/",
      beforeEnter: requireAuth(),
      component: () => import("@/views/HomePage.vue"),
    },
    {
      path: "/sign-in",
      component: () => import("@/views/sign/in/SignIn.vue"),
      meta: {
        layout: "auth",
      },
    },
    ...management,
    ...board,
    ...error,
    {
      path: "*",
      redirect: "/error/404",
    },
  ];
};

export default new Router({
  mode: "history",
  base: import.meta.env.BASE_URL,
  scrollBehavior(_to: Route, _from: Route, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: routes(),
});
